module.exports = __webpack_public_path__ + "static/media/DSC03495.9179e7bd.JPG";